import { GridContainer, GridWrapper, ZoneB, ZoneC } from "./styles/Grid.styled";
import React from "react";
import styled from "styled-components";
import { useState } from "react";
import query from "../../../server/constants.api";
import { useEffect } from "react";
import renderComponent from "../../../utils/serializers/renderComponent";
import useMultipleFetch from "../../../server/useMultipleFetch";
import { useConfigContext } from "../../../contexts/ConfigContext";
import TestBallWidget from "../../Widgets/TestBallWidget";

const ZoneA = styled.div`
  grid-column: col1;
  grid-row: 1 / -1;
  display: ${props => (props.visible ? 'grid' : 'none')};
  grid-template-columns: 1fr;
  grid-template-rows: ${props => (props.rows ? props.rows : '0.5fr 0.5fr 2fr 1fr')};
`;

const ZoneD = styled.div`
  grid-column: col3;
  grid-row: 1 / -1;
  display: ${props => (props.visible ? 'grid' : 'none')};
  grid-template-columns: 1fr;
  grid-template-rows: ${props => (props.rows ? props.rows : '1fr 1fr 2fr 1fr')};
  max-height: 100vh;
`;

const StyledZoneB = styled(ZoneB)`
  display: ${props => (props.visible ? 'grid' : 'none')};
`;

const StyledZoneC = styled(ZoneC)`
  display: ${props => (props.visible ? 'grid' : 'none')};
`;

const LayoutDefault = () => {
  const { currentConfig, zoneConfig } = useConfigContext();

  const queryResults = useMultipleFetch([
    { path: query.path.layoutZonaA, id: 'getLayoutZonaA' },
    { path: query.path.layoutZonaB, id: 'getLayoutZonaB' },
    { path: query.path.layoutZonaC, id: 'getLayoutZonaC' }
    // {path: query.path.layoutZonaD, id: 'getLayoutZonaD'}
  ]);

  const [layoutAData, setLayoutAData] = useState(null);
  const [forZonaAFr, setForZonaAFr] = useState(null);

  const [layoutBData, setLayoutBData] = useState(null);
  const [layoutCData, setLayoutCData] = useState(null);
  // const [layoutDData, setLayoutDData] = useState(null);

  useEffect(() => {
    setLayoutAData(queryResults[0]?.data?.data);
  }, [queryResults[0]?.isLoading]);

  useEffect(() => {
    setLayoutBData(queryResults[1]?.data?.data);
    // setLayoutCData(queryResults[2]?.data?.data);
  }, [queryResults[1]?.isLoading]);

  useEffect(() => {
    setLayoutCData(queryResults[2]?.data?.data);
  }, [queryResults[2]?.isLoading]);

  // useEffect(() => {
  //   setLayoutDData(queryResults[3]?.data?.data);
  // }, [queryResults[3]?.isLoading]);

  return (
    <>
      <GridWrapper>
        <GridContainer zonaD={zoneConfig?.zoneD?.visible || currentConfig?.LayoutZonaD}>
          <ZoneA rows={forZonaAFr} visible={zoneConfig?.zoneA?.visible}>
            {zoneConfig?.zoneA?.testMode ? (
              <TestBallWidget size="300px" zoneName="Zone A - Test Mode" />
            ) : layoutAData ? layoutAData?.map((element) => {
              return renderComponent(element)
            }) : <TestBallWidget size="200px" zoneName="Zone A - No Data" />}
          </ZoneA>
          
          <StyledZoneB visible={zoneConfig?.zoneB?.visible}>
            {zoneConfig?.zoneB?.testMode ? (
              <TestBallWidget size="400px" zoneName="Zone B - Test Mode" />
            ) : layoutBData ? layoutBData?.map((element) => {
              return renderComponent(element)
            }) : <TestBallWidget size="250px" zoneName="Zone B - No Data" />}
          </StyledZoneB>
          
          <StyledZoneC visible={zoneConfig?.zoneC?.visible}>
            {zoneConfig?.zoneC?.testMode ? (
              <TestBallWidget size="350px" zoneName="Zone C - Test Mode" />
            ) : layoutCData ? layoutCData?.map((element) => {
              return renderComponent(element)
            }) : <TestBallWidget size="250px" zoneName="Zone C - No Data" />}
          </StyledZoneC>
          
          {(zoneConfig?.zoneD?.visible || currentConfig?.LayoutZonaD) ? (
            <ZoneD visible={zoneConfig?.zoneD?.visible}>
              {zoneConfig?.zoneD?.testMode ? (
                <TestBallWidget size="300px" zoneName="Zone D - Test Mode" />
              ) : currentConfig?.LayoutZonaD ? currentConfig?.LayoutZonaD.map((element) => {
                return renderComponent(element)
              }) : <TestBallWidget size="200px" zoneName="Zone D - No Data" />}
            </ZoneD>
          ) : null}

        </GridContainer>
      </GridWrapper>
    </>
  );
}

export default LayoutDefault;